module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraBlackItalic.1f20b532.woff";